<template>
    <ul class="progress-container">
        <li :class="active >= 1 ? 'active' : ''">{{ $t('carrito.cesta') }}</li>
        <li :class="active >= 2 ? 'active' : ''">{{ $t('carrito.datos') }}</li>
        <li :class="active >= 3 ? 'active' : ''">{{ $t('carrito.pago') }}</li>
        <li :class="active >= 4 ? 'active' : ''">{{ $t('carrito.compra_confirmada') }}</li>
    </ul>
</template>

<script>
    export default {
        props: {
            active: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style scoped>
.progress-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0;
    padding: 0;
    list-style: none;
    position: relative;
}

.progress-container li {
    position: relative;
    flex: 1;
    color: grey;
    font-size: 16px;
}

.progress-container li.active {
    font-weight: bold;
    color: black;
}

.progress-container li::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: lightgrey;
    top: 50%;
    left: 24%;
    width: 70%;
}

.progress-container li:last-child::before {
    content: none;
}

.progress-container li.active + li::before {
    background-color: lightgrey;
}
</style>